var path = '/templates/zenclerk_s/layout/layout_header+main.html';
var html = "<div class=zenclerk-zcs-container ng-class=\"{'with-header': !ZcsOemService.get()}\"><div class=ui-view-container><div class=ui-view-page-content><zcs-header></zcs-header><zcs-main></zcs-main><zcs-footer></zcs-footer></div></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/zenclerk_s_modules/zenclerk_s/layout/layout_header+main.html
// module id = 1366
// module chunks = 0